import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Observable, of, Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
declare let $: any;
import { map, tap } from 'rxjs/operators';
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { environment } from '../environments/environment';
// import { tap, shareReplay } from "rxjs/operators";
// @Injectable()
// export class CacheInterceptor implements HttpInterceptor {
//   private cache = new Map<string, any>();
//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     if (request.method !== "GET") {
//       return next.handle(request);
//     }
//     const cachedResponse = this.cache.get(request.url);
//     if (cachedResponse) {
//       return of(cachedResponse);
//     }
//     return next.handle(request).pipe(
//       tap(event => {
//         if (event instanceof HttpResponse) {
//           this.cache.set(request.url, event);
//         }
//       })
//     );
//   }
// }
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // Development
  // serverUrl = "http://admin_server.maharah.neumtech.net/api/";
  // serverUrl = "https://admin.demo.maharahapp.com/api/";


  // staging Development
  // serverUrl = "http://admin_server.maharah_staging.neumtech.net/api/";

  // Prodction
  // serverUrl = 'https://admin_server.imaharah.net/api/';
  //  serverUrl = "https://uat-admin.imaharah.net/api/"

  // k8 Production
  serverUrl = environment.serverUrl;


  //Development
  // fileserverUrl = "http://file_server.maharah.neumtech.net/api/";
  fileserverUrl = environment.fileServerUrl

  // S3 file upload url 
  // s3Url = "http://file_server.maharah.neumtech.net/api/Storages/uploadImage?folder=";
  // viewUrl = "https://maharah-app-images.s3.amazonaws.com/"


  s3Url = environment.s3Url;
  viewUrl = environment.viewUrl

  jobData: any;
  job_id: Number;
  role: any;
  //self: any;
  constructor(
    private router: Router,
    private _http: Http,
    private snackBar: MatSnackBar

  ) {
    var self = this;
    if (!this.role) {
      this.role = localStorage.getItem('role');
    }
    // console.log(this.role);
    // this.getLoginDetails();
  }

  httpConnect(method, path, urlParams, postParams = {}) {
    // var url = this.countryCodeUrl;
    // urlParams.access_token = localStorage.getItem('token');
    var url = path;
    if (method == 'post') {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      postParams = JSON.stringify(postParams);
      let options = { headers: headers, params: urlParams };
      return this._http
        .post(url, postParams, options)
        .pipe(map(res => res.json()));
    } else if (method == 'get') {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      let options = { headers: headers, params: urlParams };
      return this._http.get(url, options).pipe(
        map(
          res => res.json(),
          err => err.json
        )
      );
    }
  }

  
  getcustomeronlineData(method, path, urlParams, postParams = {}) {
    var url = this.serverUrl;
    urlParams.access_token = localStorage.getItem('token');
    url = url + path;
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append(
      'authorization',
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQD3apAg6H2iQdqDup1pgSc0tQUM'
    );
    headers.append('admin_server_version', '3.3');
    if (method == 'post') {
      postParams = JSON.stringify(postParams);
      let options = { headers: headers, params: urlParams };

      let response = this._http.post(url, postParams, options).pipe(
        map(res => res.json()),
        tap(
          data => {
            return data;
          },
          err => {
            console.log(err);
            if (err.status == 401) {
              this.router.navigate(['../../login']);
            }
            this.alert(err.statusText);
            return err;
          }
        )
      );
      return response;
    } else if (method == 'get') {
      let options = { headers: headers, params: urlParams };

      let response = this._http.get(url, options).pipe(
        map(
          res => res.json(),
          err => err.json(),
        ),
        catchError(err => {
          if (err.status == 401) {
            console.log('error showing')
            // this.router.navigate(["../../login"]);
          }
          this.alert(err.statusText);
          return of('Z');
        })
      );

      return response;
    }
  }


  httpService(method, path, urlParams, postParams = {}) {
    var url = this.serverUrl;
    urlParams.access_token = localStorage.getItem('token');
    url = url + path;
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append(
      'authorization',
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQD3apAg6H2iQdqDup1pgSc0tQUM'
    );
    headers.append('admin_server_version', '3.3');
    if (method == 'post') {
      postParams = JSON.stringify(postParams);
      let options = { headers: headers, params: urlParams };
      let response = this._http.post(url, postParams, options).pipe(
        map(res => res.json()),
        tap(
          data => {
            return data;
          },
          err => {
            console.log(err);
            if (err.status == 401) {
              this.router.navigate(['../../login']);
            }
            this.alert(err.statusText);
            return err;
          }
        )
      );
      // response.subscribe(data => {
      // },error => {
      //   if(error.status==401){
      //     this.router.navigate(['../../login']);
      //   }
      //   console.log(error.status);
      // });
      return response;
    } else if (method == 'get') {
      let options = { headers: headers, params: urlParams };
      let response = this._http.get(url, options).pipe(
        map(
          res => res.json(),
          err => err.json()
        ),
        catchError(err => {
          if (err.status == 401) {
            this.router.navigate(['../../login']);
          }
          this.alert(err.statusText);
          return of('Z');
        })
      );

      return response;
    }
  }


  handleError(error) {
    if (error.status == 401) {
      this.router.navigate(['../../login']);

      return false;
    }
    return error;
  }

  upload(path, file) {
    let data = new FormData();
    data.append('file', file);
    return this._http
      .post(this.fileserverUrl + path, data)
      .pipe(map(res => res.json()));
  }
// Not work
//  uploads(path: string, file: File) {
//   const uploadUrl = `${environment.fileServerUrl}Storages/uploadImage?folder=${path}`;
//   const data = new FormData();
//   data.append('file', file);
  
//   return this._http.post(uploadUrl, data).pipe(
//     map(res => res.json())
//   );
// }

uploads(path, file) {
  let data = new FormData();
  data.append('file', file);
  return this._http
    .post(this.s3Url + path, data)
    .pipe(map(res => res.json()));
}
  alert(message: string) {
    this.snackBar.open(message, 'Close', {
      duration: 2000,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }

  private handleErrorObservable(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.message || error);
  }
  private handleErrorPromise(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }
  refundSubscriptionFees(): Observable<any> {
    return this.httpService('post', 'Vendors/refundSubscriptionFees', {}, {});
  }
  // private handleError(error: Response) {
  //   //  console.error(error);
  //   if (error.status == 0) {
  //     //  alert("No Network Connectivity");
  //   } else {
  //     // alert("Error");
  //   }
  //   return Observable.throw(error.json().error || " error");
  // }
}